module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "收货地址"
    }
  }), _vm._v(" "), (!_vm.list.length) ? _c('not-data', {
    attrs: {
      "imgPic": "address"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item._id,
      on: {
        "click": function($event) {
          _vm.addrIdTap(item)
        }
      }
    }, [_c('div', {
      staticClass: "vux-1px-b info-top"
    }, [_c('div', {
      staticClass: "info-head flex"
    }, [_c('span', [_vm._v("收货人：" + _vm._s(item.name) + " ")]), _vm._v(" "), _c('span', [_vm._v("电话：" + _vm._s(item.mobileNumber))])]), _vm._v(" "), _c('div', {
      staticClass: "address text-l"
    }, [_vm._v("\n                        收货地址：" + _vm._s(item.area) + " " + _vm._s(item.location) + "\n                    ")])]), _vm._v(" "), _c('div', {
      staticClass: "info-btm flex"
    }, [_c('div', {
      staticClass: "flex-1 text-l",
      on: {
        "click": function($event) {
          _vm.setDefult(item)
        }
      }
    }, [_c('icon', {
      class: {
        active: item.default
      },
      attrs: {
        "type": "success"
      }
    }), _c('span', [_vm._v("设为默认收获地址")])], 1), _vm._v(" "), _c('div', {
      staticClass: "flex editor"
    }, [_c('button', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.editorTab(item)
        }
      }
    }, [_vm._v("编辑")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.delAddress(item, index)
        }
      }
    }, [_vm._v("删除")])])])])
  }))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "footer",
      "to": {
        name: 'AddAddress',
        params: {
          pathName: 'add'
        }
      }
    }
  }, [_c('b', [_c('i', {
    staticClass: "iconfont icon-jia"
  })]), _vm._v("新增收货地址")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-433478fe"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShippingAddress/ShippingAddress.vue
// module id = 546
// module chunks = 0